import { render, staticRenderFns } from "./Unit5PNG.vue?vue&type=template&id=022b19d1&scoped=true&"
import script from "./Unit5PNG.vue?vue&type=script&lang=js&"
export * from "./Unit5PNG.vue?vue&type=script&lang=js&"
import style0 from "./Unit5PNG.vue?vue&type=style&index=0&id=022b19d1&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022b19d1",
  null
  
)

export default component.exports